import React from 'react'
import { Link, graphql } from 'gatsby'
import '../layouts/tachyons/css/tachyons.css';
import '../layouts/custom.css';
import { Title1, Title2, Title3, Large, Medium, Small, Tiny, Micro, BuddyLink } from "../components/typography"
import { Divider, SectionFeatured, SectionOuter, SectionWork, SectionContact, SectionTestimonial, SectionFeaturedWork, NavLink, NavLinkList, FooterLink, FooterLinkList, SectionAboutHero, WorkList, WorkListClient } from "../components/section"
import Footer from '../components/footer'
import NavDribbble from '../components/navdribbble'
import Fade from 'react-reveal/Fade';
import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';
import SEO from "../components/seo"


export default ({ data }) => (
        <div className="sans-serif">

            <SEO title="Dribbble" keywords={[`product designer`, `product strategist`, `UI Design`,`User Experience` ,`UX Designer Jakarta`]} />
            <NavDribbble/>

            <section className="ph6-ns pt5-ns pb3-ns ph5-m pb5-m ph4 pt5 pb5 w-90-ns w-100-m"></section>

            <SectionWork className="dribbble mt0-m pt6-ns pb0-ns pb4-m pt5 pb4" >
                <SectionOuter>
                <Fade top duration={800} distance={"3em"} delay={300} >
                    <Title1 className="white mt6-ns mt5-m mt4 mb0-ns measure-narrow">Dribbble Shots</Title1>
                </Fade>
                </SectionOuter>
            </SectionWork>

            <SectionOuter className="pt6-ns pb5-ns pt4-m pb4-m mt4-m pt4">
                <Fade top duration={800} delay={600} distance={"2em"}>
                {data.allDribleProjects.edges.map((edge, i) => (
                    <article className="w-third-ns w-third-m fl mb4-ns mb4 dribbble-awal dribbble-tengah dribbble-akhir">
                        <a href={edge.node.url} target="_blank">
                        <img src={edge.node.cover} className="grow db no-underline black ba bw3 br2 b--near-white"/></a>
                    </article>
                    ))}
                </Fade>    
                <div className="cf"></div>
            </SectionOuter>

            <SectionOuter className="pt0-ns pb6-ns pt4 pb5 pb0-m tc"><a class="f5 link dim ph4 pv3 mb2 dib fw6 c--black1 bg--grey5" href="https://dribbble.com/thebuddyman" target="_blank">More shots</a></SectionOuter>
                    
            
            <div className="cf"></div>
            <Footer/>


        </div>
      )


  export const query = graphql`
  {
    allDribleProjects(limit: 12) {
        edges {
            node {
                title
                description
                id
                published
                updated
                url
                tags
                cover
                width
                height
            }
        }
    }
}
`

  